import axios from 'axios'

const login = async (email, password) => {
    return axios.post(`${import.meta.env.VITE_SERVER_BASE_URL}/users/login`, {
        user: { email, password },
    })
}

const getCurrentUserProfile = async (token) => {
    const result = axios.get(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/profile`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    )
    return result
}

const getGoogleAuthStartUrl = (redirectUrl = '/dashboard') => {
    const base = import.meta.env.VITE_SERVER_BASE_URL
    return `${base}/google/auth/start?redirectUrl=${encodeURIComponent(redirectUrl)}`
}

const parseLoginHash = () => {
    const hash = window.location.hash?.startsWith('#')
        ? window.location.hash.slice(1)
        : window.location.hash
    if (!hash) {
        return null
    }
    const params = new URLSearchParams(hash)
    const token = params.get('token')
    if (!token) {
        return null
    }
    return {
        token,
        redirectUrl: params.get('redirectUrl') || '/dashboard',
    }
}

const clearLoginHash = () => {
    const path = window.location.pathname + window.location.search
    window.history.replaceState(null, '', path)
}

const LOGIN_ERROR_MESSAGES = {
    google_auth_failed: 'Google sign-in failed. Please try again.',
    user_disabled: 'This account is disabled. Contact an administrator.',
}

export {
    login,
    getCurrentUserProfile,
    getGoogleAuthStartUrl,
    parseLoginHash,
    clearLoginHash,
    LOGIN_ERROR_MESSAGES,
}
